import NotConnectedState from 'components/NotConnectedState';
import usePulseEmptyStateConfig from '../usePulseEmptyStateConfig';

const TeamSpaceEmptyState = ({ emptyStateType }) => {
  const emptyStateConfig = usePulseEmptyStateConfig(emptyStateType);

  if (!emptyStateType) return null;

  return <NotConnectedState {...emptyStateConfig} />;
};

export default TeamSpaceEmptyState;
